module.exports = __webpack_public_path__ + "static/img/gift-box-reward-dia.c1da7fe.png";